import * as React from "react";

import "./tooltip.scss";

export interface TooltipBoundary {
    top: number;
    height: number;
    left: number;
    width: number;
}

export interface TooltipCoordinate {
    left: number;
    top: number;
}

interface Props {
    pos: TooltipCoordinate;
    bubbleContent: JSX.Element;
    bubbleStyle?: React.CSSProperties;
    bubbleClassName?: string;
    boundary?: TooltipBoundary;
}

export class Tooltip extends React.Component<Props> {

    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div className={"fill-parent"} style={{position: "relative"}}>
                {this.props.children}
                <ToolTipBubble
                    pos={this.props.pos}
                    visible={this.props.pos !== undefined && this.props.pos !== null}
                    style={this.props.bubbleStyle}
                    className={this.props.bubbleClassName}
                    boundary={this.props.boundary}
                >
                    {this.props.bubbleContent}
                </ToolTipBubble>
            </div>
        );
    }
}

interface BubbleProps {
    className?: string;
    pos: TooltipCoordinate;
    style?: React.CSSProperties;
    visible: boolean;
    boundary?: TooltipBoundary;
}

interface BubbleState {
    pos: TooltipCoordinate;
}

// tslint:disable-next-line:max-classes-per-file
export class ToolTipBubble extends React.Component<BubbleProps, BubbleState> {

    private bubbleRef: React.RefObject<any>;
    private bottomTriangle: React.RefObject<any>;

    constructor(props) {
        super(props);
        this.bubbleRef = React.createRef();
        this.bottomTriangle = React.createRef();
        this.state = {
            pos: this.props.pos,
        };
    }

    public componentDidUpdate(prevProps: Readonly<BubbleProps>, prevState: Readonly<BubbleState>, snapshot?: any) {
        if (this.bubbleRef.current) {
            this.bubbleRef.current.style.left = this.props.pos.left + "px";
            this.bubbleRef.current.style.top = this.props.pos.top + "px";

            const bRight = this.props.boundary.left + this.props.boundary.width;

            // Check for left right and top boundaries
            const width = this.bubbleRef.current.clientWidth;
            if (this.props.pos.left - (width / 2) < 0) {
                this.bubbleRef.current.style.left = (width / 2) + "px";
                this.bottomTriangle.current.style.left = this.props.pos.left + "px";
            } else if (this.props.pos.left + (width / 2) > bRight) {
                this.bubbleRef.current.style.left = (bRight - width / 2) + "px";

                const fromRight = bRight - this.props.pos.left;

                this.bottomTriangle.current.style.left = (width - fromRight) + "px";
            }
        }
    }

    public render() {
        if (!this.props.visible) {
            return null;
        }
        return (
            <div
                className={"tooltip-bubble"}
                ref={this.bubbleRef}
            >
                <div
                    className={this.props.className}
                    style={this.props.style}
                >
                    {this.props.children}
                </div>
                <div
                    className={"tooltip-bubble-bottom-triangle"}
                    ref={this.bottomTriangle}
                    style={{
                        borderTopColor: this.props.style.backgroundColor,
                    }}
                />
            </div>
        );
    }
}
